<template>
  <div class="filters-container">
    <div class="inner-container">
      <div class="header-box">
        <h2>{{ title }}</h2>
        <span v-if="baseline" class="baseline">{{ baseline }}</span>
        <i class="icon-cross" @click="action"></i>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ['action', 'title', 'baseline'],
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.filters-container {
  position: fixed;
  top: 104px;
  bottom: 0;
  left: 54px;
  z-index: 2;
  background-color: colors.$white-color;
  box-sizing: border-box;
  width: 268px;
  overflow: auto;
  box-shadow: 0 2px 4px rgba(colors.$black-color, 0.25);

  .inner-container {
    position: relative;
    padding: 24px 0 0 12px;
  }

  .header-box {
    height: 64px;
    box-sizing: border-box;
    padding: 12px 16px;
    border-bottom: 1px solid colors.$clear-border-color;

    h2 {
      font-weight: 700;
      color: colors.$near-dark-color;
      font-size: 16px;
      min-height: 40px;
      padding: 0 12px 0 0;

      &:first-letter {
        text-transform: uppercase;
      }
    }
    .baseline {
      color: colors.$nude-concrete-color;
      font-size: 12px;
      margin-top: -0.725em;
      display: block;
    }
    i {
      font-size: 1.75em;
      position: absolute;
      top: 32px;
      right: 8px;
      cursor: pointer;
      transition: color 0.2s ease;
      &:hover {
        color: colors.$navy-color;
      }
    }
  }
}
</style>
